// @flow

import Paging from './paging';

export default class PagedResults<T> {
  currentPage: number;
  numberOfPages: number;
  items: T[];

  constructor({ currentPage, numberOfPages, items }: $ReadOnly<PagedResults<T>>) {
    this.currentPage = currentPage;
    this.numberOfPages = numberOfPages;
    this.items = items;
  }

  getPaging() {
    return new Paging({
      currentPage: this.currentPage,
      numberOfPages: this.numberOfPages,
    });
  }

  static parse<V>(mapper: Object => V, data: Object): PagedResults<V> {
    const items: V[] = data.items.map(mapper);

    return new PagedResults({
      currentPage: data.currentPage,
      numberOfPages: data.numberOfPages,
      items,
    });
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/pagination/domain/pagedResults.js